import { css } from '@emotion/react';

import { screen } from '@/components/common/breakpoints';
import { bodySmallBold } from '@/styles/typography';

// Misc css variables that don't fit anywhere else
export const misc = css`
  :root {
    --opacity-disabled: 64%;
    --desktop-max-width: 1440px;
    --desktop-max-content-width: 1312px;
    --mobile-min-width: 320px;
    --shadow-base: 0px 4px 54px 0px rgb(0, 0, 0, 10%);
    --shadow-subtle: 0px 6px 112px 0px rgb(0, 0, 0, 5%);

    --banner-height: var(--spacing-700);
    --navbar-height: 48px;

    --section-radius: var(--radius-300);

    --full-navbar-height: calc(
      var(--navbar-height) + var(--spacing-medium) + 1px
    );

    ${screen.sm} {
      --navbar-height: 56px;
    }

    ${screen.md} {
      --banner-height: 64px;
      --navbar-height: 85px;
      --navbar-top: var(--spacing-x-large);

      --full-navbar-height: calc(
        var(--navbar-height) + var(--navbar-top) + 1px
      );

      --section-radius: var(--radius-450);
    }
  }
`;

export const styledLink = css`
  ${bodySmallBold}
  color: var(--text-action);
  text-decoration-color: var(--icon-action);
  text-decoration: underline;
  text-underline-offset: var(--spacing-50);
  width: fit-content;
  padding: 0 1px;
  line-height: 19.2px;

  &:hover {
    background-color: var(--decorative-starlight);
  }

  &:focus,
  &:focus-within,
  &:focus-visible {
    text-decoration: none;
    outline: 1px solid var(--icon-action-dark);
    outline-offset: var(--spacing-50);
    border-radius: var(--radius-xxs);
  }

  &.disabled,
  &:disabled,
  &[disabled] {
    opacity: var(--opacity-disabled);
    pointer-events: none;
  }

  &:visited {
    color: var(--decorative-galaxy);
  }
`;
